import { ALMThemeProvider } from 'alm-react-components';
import { Amplify } from 'aws-amplify';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import { Toaster } from './components/common/Toaster';
import { awsConfig } from './configuration';
import { AppProvider } from './context/AppProvider';
import i18n from './lang/config';
import { customHistory } from './lib/utils';
import { CustomRouter } from './routes/CustomRouter';
import 'moment/dist/locale/en-in';
import 'moment/dist/locale/nl';
import moment from 'moment';
import reactGA from 'react-ga';

import { constants } from './assets/constants/constants';
Amplify.configure(awsConfig);
const analyticsKey = import.meta.env.VITE_ANALYTICS_KEY || 'default_key';
reactGA.initialize(analyticsKey);
moment.locale(localStorage.getItem('i18nextLng') ?? constants.dutchCode)
function ThemeProvider() {
  return (
    <ALMThemeProvider defaultTheme="dark">
      <AppProvider>
        <I18nextProvider i18n={i18n}>
          <CustomRouter history={customHistory}>
            <div className="z-[9999] relative">
              <Toaster position="tr" />
            </div>
            <App />
          </CustomRouter>
        </I18nextProvider>
      </AppProvider>
    </ALMThemeProvider>
  );
}

export default ThemeProvider;
